import React from "react";
import { ycCompanies } from "assets/ycCompanies";
import ClientOrderItem from "./ClientOrderItem";

const headerColumns = {
  client: {
    name: "Client",
    width: "25%",
  },
  orderId: {
    name: "ID",
    width: "5%",
  },
  orderUsername: {
    name: "Username",
    width: "15%",
  },
  roleName: {
    name: "Role",
    width: "15%",
  },
  roleLocaiton: {
    name: "Location",
    width: "15%",
  },
  orderStatus: {
    name: "Status",
    width: "5%",
  },
  dateCreated: {
    name: "Created",
    width: "10%",
  },
  lastActive: {
    name: "Last Active",
    width: "10%",
  },
};

export default function ClientOrdersPageTable() {
  return (
    <table className="w-full text-sm text-left">
      <thead className="text text-gray-800 bg-gray-59">
        <tr>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.client.width }}>
            {headerColumns.client.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderId.width }}>
            {headerColumns.orderId.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderUsername.width }}>
            {headerColumns.orderUsername.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.roleName.width }}>
            {headerColumns.roleName.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.roleLocaiton.width }}>
            {headerColumns.roleLocaiton.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.orderStatus.width }}>
            {headerColumns.orderStatus.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.dateCreated.width }}>
            {headerColumns.dateCreated.name}
          </th>
          <th scope="col" className="px-6 py-3" style={{ width: headerColumns.lastActive.width }}>
            {headerColumns.lastActive.name}
          </th>
        </tr>
      </thead>
      <tbody>
        {ycCompanies.map((company) => (
          <ClientOrderItem company={company} />
        ))}
      </tbody>
    </table>
  );
}
